import { render, staticRenderFns } from "./ForgetPassword.vue?vue&type=template&id=c797e924&scoped=true&"
import script from "./ForgetPassword.vue?vue&type=script&lang=ts&"
export * from "./ForgetPassword.vue?vue&type=script&lang=ts&"
import style0 from "./ForgetPassword.vue?vue&type=style&index=0&id=c797e924&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c797e924",
  null
  
)

export default component.exports